import "./matchComplete.sass";
import { useEffect, useState } from "react";
import MatchScore from "./matchScore/matchScore";
import MatchInformation from "./matchInformation/matchInformation";
import { getMatch, transformMatchData } from "../../../services/minute-a-minute/getMatch";
import { useAutoRefresh } from "../hooks/useAutoRefresh";
import Loading from "../../loading/loading";

export default function MatchComplete({ matchId = null, type = "minuto-a-minuto", refresh = false, country = null }) {
  const [matchData, setMatchData] = useState(null);
  const [loading, setLoading] = useState(!!matchId);
  const [error, setError] = useState(null);

  // Función para obtener datos con o sin loading
  const fetchMatchCompleteData = async (showLoading = true) => {
    if (!matchId) {
      setError("No se proporcionó el ID del partido");
      setLoading(false);
      return;
    }

    try {
      if (showLoading) setLoading(true);

      // Hacer una única petición para obtener todos los datos
      const apiData = await getMatch(matchId, country);
      const transformed = transformMatchData(apiData);
      
      setMatchData(transformed);
      setError(null);
    } catch (err) {
      console.error("Error cargando datos del partido:", err);
      setError(err.message || "Error cargando datos del partido");
    } finally {
      if (showLoading) setLoading(false);
    }
  };

  // Usar hook de auto-refresh si refresh es true
  useAutoRefresh(refresh, fetchMatchCompleteData, [matchId, refresh, country]);

  // Cargar datos iniciales si refresh es false
  useEffect(() => {
    if (!refresh) {
      fetchMatchCompleteData(true);
    }
  }, [matchId, refresh, country]);

  if (loading) {
    return (
      <div className="match-complete-container">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="match-complete-container">
        <div className="error-message">Error: {error}</div>
      </div>
    );
  }

  if (!matchData) {
    return (
      <div className="match-complete-container">
        <div className="empty-message">No se encontraron datos del partido</div>
      </div>
    );
  }

  return (
    <div className="match-complete-container">
      {/* MatchScore recibe datos transformados */}
      <MatchScore
        matchData={matchData}
        homeTeam={matchData.homeTeam}
        awayTeam={matchData.awayTeam}
        score={matchData.score}
        competition={matchData.competition}
        date={matchData.date}
        venue={matchData.venue}
        status={matchData.status}
      />

      {/* MatchInformation recibe datos transformados */}
      <MatchInformation
        matchData={matchData}
        events={matchData.events || []}
        matchInfo={matchData.matchInfo}
        homeTeamInfo={matchData.homeTeamInfo}
        awayTeamInfo={matchData.awayTeamInfo}
        homeTeamId={matchData.homeTeam?.id}
        type={type}
        country={country}
      />
    </div>
  );
}